
import Home from '../components/Home';

const PageHome = () => {
  return <Home />;
};

export default PageHome;
